import gql from "graphql-tag";

export default gql`
  query ValuationIndicatorHistoryForTickerSymbols(
    $tickerSymbols: [TickerSymbol!]!
    $securityCountry: SecurityCountry!
    $indicator: ValuationIndicator!
    $verbiageLanguage: ValuationIndicatorVerbiageLanguage!
    $period: ValuationPeriod!
  ) {
    valuationIndicatorHistoryForTickerSymbols(
      tickerSymbols: $tickerSymbols
      country: $securityCountry
      indicator: $indicator
      period: $period
    ) {
      tickerSymbol
      nodes {
        category
        verbiage(language: $verbiageLanguage) {
          abbreviation
          formula
          description
        }
        indicator
        asOfDate
        value
        formattedValue
      }
    }
  }
`;
